import { render, staticRenderFns } from "./img.vue?vue&type=template&id=74236b87&"
import script from "./img.vue?vue&type=script&lang=js&"
export * from "./img.vue?vue&type=script&lang=js&"
import style0 from "./img.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports